import { defineStore } from 'pinia';
export const useStatusStore = defineStore('status', {
    state: () => {
        return {
            _agentsOnline: null,
            _agents: [],
            _emailAddressFound: false
        };
    },
    getters: {
        agentsOnline: (state) => state._agentsOnline,
        agents: (state) => state._agents,
        emailAddressFound: (state) => state._emailAddressFound,
    },
    actions: {
        setAgentOnline(b) {
            this._agentsOnline = b;
        },
        setEmailAddressFound(b) {
            this._emailAddressFound = b;
        },
        updateAgents(agents) {
            this._agents = agents;
        }
    },
});
